import { render } from "./JoinEvent.vue?vue&type=template&id=6b585f26"
import script from "./JoinEvent.vue?vue&type=script&lang=js"
export * from "./JoinEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__